import { B2B_SITE_ORIGIN } from "@danishagro/shared/src/constants/urlRoot.constants";
import { DA_DeliveryInfoModalData } from "@interfaces/deliveryInfoModalData.interface";

export const getDeliveryInfoModalContent = (): Promise<DA_DeliveryInfoModalData> =>
    fetch(`${B2B_SITE_ORIGIN}/api/modal/Leveringsinformation`).then((response) => response.json());
